import { types } from "../actions/remarksDialog";

const initialState = {
  documents: {},
};

const remarksDialogReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.UPDATE_DOCUMENT: {
      const doc = action.payload;
      console.log("doc in reducer:", doc);
      return {
        ...state,
        // ...state.documents,
        // ...state.documents[doc.id],
        ...doc,
      };
    }
    default:
      return state;
  }
};

export default remarksDialogReducer;
